import { render } from "./HomePageShimmer.vue?vue&type=template&id=e9d68aa8"
import script from "./HomePageShimmer.vue?vue&type=script&lang=js"
export * from "./HomePageShimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__